module.exports = __webpack_public_path__ + "static/media/svg13.91c32f29.svg";